import { render, staticRenderFns } from "./medicalInformation.vue?vue&type=template&id=9b434358&scoped=true&"
import script from "./medicalInformation.vue?vue&type=script&lang=js&"
export * from "./medicalInformation.vue?vue&type=script&lang=js&"
import style0 from "./medicalInformation.vue?vue&type=style&index=0&id=9b434358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b434358",
  null
  
)

export default component.exports